var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7666 40.5987C39.1013 39.526 38.6186 38.6367 37.95 36.962C36.8193 34.1333 44.8266 31.5773 41.58 26.666C42.9873 30.0587 36.5286 32.156 35.9286 34.9813C35.38 37.58 39.7633 40.5987 39.7666 40.5987Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9187 35.5133C39.7907 37.1907 41.4047 38.0847 41.4514 39.31C41.4887 40.3073 40.4867 41.1387 40.4867 41.1387C40.4867 41.1387 42.3054 40.7813 42.8727 39.26C43.5027 37.5707 41.6501 36.414 41.8407 35.0613C42.0187 33.7693 45.8614 31.366 45.8614 31.366C45.8614 31.366 40.2074 31.7407 39.9187 35.5133Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3894 40.7033C46.5587 40.4407 47.5447 41.1853 47.5447 42.0433C47.5447 43.9773 44.864 45.8053 44.864 45.8053C44.864 45.8053 49.014 45.3107 49.014 42.1353C49.014 40.0353 46.976 39.5107 45.3894 40.7033ZM43.4194 42.2633C43.4194 42.2633 44.7134 41.3413 45.058 40.9953C41.8827 41.6693 34.6327 41.76 34.6327 41.1747C34.6327 40.6353 36.9707 40.0827 36.9707 40.0827C36.9707 40.0827 31.7887 40.008 31.7887 41.5367C31.7887 43.13 38.572 43.244 43.4194 42.2633Z",
    fill: "#1565C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6234 43.714C39.6174 44.7133 34.0807 44.394 35.7207 43.052C34.922 43.052 33.738 43.694 33.738 44.3113C33.738 45.5493 39.726 46.5053 44.158 44.6927L42.6234 43.714Z",
    fill: "#1565C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4573 45.826C35.3666 45.826 34.6606 46.5287 34.6606 47.0407C34.6606 48.6347 41.1673 48.7953 43.7453 47.1773L42.1066 46.0893C40.1806 46.936 35.3426 47.0527 36.4573 45.826Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1873 48.4213C48.1873 47.7973 47.484 47.5033 47.232 47.3627C48.7173 50.9447 32.354 50.6667 32.354 48.552C32.354 48.0713 33.5587 47.6007 34.672 47.8233L33.7253 47.264C31.5067 46.916 30 47.8913 30 48.678C30 52.3467 48.1873 52.17 48.1873 48.4213Z",
    fill: "#1565C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49.736C47.236 52.466 40.2273 53.4607 33.1793 51.774C40.2273 54.776 49.9667 53.0853 50 49.736Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.c461e1c318c4d0bc44272587d9d54820.svg";
export { ForwardRef as ReactComponent };